import { EIGHT_SIXTEEN_PASSWORD_REG, PIN_REG, MOBILE_REG } from "@lhb/regexp";
export var rules = {
    mobile: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
    ],
    password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { pattern: EIGHT_SIXTEEN_PASSWORD_REG, message: '请输入8-16位密码,至少存在字母和数字', trigger: 'blur' },
    ],
};
export var codeFormRules = {
    mobile: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        { pattern: MOBILE_REG, message: '请输入手机号', trigger: 'blur' },
    ],
    code: [
        { required: true, message: '请输入验证码', trigger: 'blur' },
        { pattern: PIN_REG, message: '请输入有效的验证码', trigger: 'blur' },
    ],
};
